import { Button } from "../../components/Button";
import { TextArea } from "../../components/Form";
import { LoadingWithLabel } from "../../components/Loading";
import { ModalBody, ModalDouble, ModalFooter, ModalHeader, ModalPanel } from "../../components/Modal";
import { Grid } from "../../components/Table";
import './styles.scss';

export const SendFormScreen = ({
  modalIsOpen,
  handleCloseModal,
  selectedUsers,
  handleConfirmedUsers,
  usersAreConfirmed,
  sending,
  sendingCount,
  generateLinkAndSendMessages,
  template,
  handleChangeTemplate
}) => {
  const columns = () => [
    { id: "name", field: "name", label: "Produtor", width: "200px" },
    { id: "email", field: "email", label: "Email", width: "200px" },
    { id: "form", field: "form", label: "Formulário", width: "300px" },
    {
      id: "questions",
      field: "questions",
      label: "Questões",
      width: "400px",
      cellRenderer: ({ data }) => (
        <div className="questions__container">
          {data?.questions && data?.questions.map((row, idx) => (
            <div className="cell-question__content">
              {idx+1}. {row.question}
            </div>
          ))}
        </div>
      ),
    },
  ]

  return <ModalPanel modalIsOpen={modalIsOpen}>
    <ModalHeader closeModal={handleCloseModal} title="Enviar Links dos Formulários" />
    <ModalBody className="modal-form">
      {
        usersAreConfirmed ?
          <>
            <ModalDouble position="left">
            {sending ? 
              <LoadingWithLabel
                labelLoading={`${sendingCount || 0}/${selectedUsers.length} link(s) gerado(s) aguarde....`}
                colorSpinner="primary"
              /> :
              <div className="modal-total-producers">
                {selectedUsers.length || 0} produtores receberão os links
              </div>
            }
            </ModalDouble>
            <ModalDouble position="right">
              <TextArea
                resize="none"
                placeholder="Escreva seu template aqui..."
                height="95%"
                value={template}
                onChange={handleChangeTemplate}
              />
            </ModalDouble>
          </>
        :
        <Grid
          columns={columns()}
          rows={selectedUsers}
        />
      }
    </ModalBody>
    <ModalFooter>
      <Button
        label="Enviar Links"
        color="orange"
        handleClick={() => usersAreConfirmed ? 
          generateLinkAndSendMessages() : 
          handleConfirmedUsers()
        }
      />
    </ModalFooter>
  </ModalPanel>
}